import clsx from 'clsx';
import Icon from 'components/ui/Icon';
import type { ReactNode } from 'react';

export type Props = {
  children?: ReactNode;
  text?: string;
  type?: 'error' | 'generic' | 'info' | 'success';
  vertical?: boolean;
};

const Alert = ({
  children,
  text,
  type = 'generic',
  vertical = true,
}: Props): JSX.Element => {
  const colors = {
    error: { bg: '#E7CBC5', text: '#7B3F33', icon: 'ErrorIcon' },
    generic: { bg: '#F1ECE4', text: '#65655B', icon: 'Info' },
    info: { bg: '#E2ECF3', text: '#366281', icon: 'Info' },
    success: { bg: '#D0E7C5', text: '#345724', icon: 'Success' },
  };

  return (
    <div
      className="lg:rounded text-sm italic p-4"
      style={{ backgroundColor: colors[type].bg, color: colors[type].text }}
    >
      <div className={clsx('flex', vertical ? 'flex-col' : 'flex-row')}>
        <Icon
          className={clsx('shrink-0', vertical ? 'mx-auto mb-4' : 'mr-6')}
          type={colors[type].icon}
          color={colors[type].text}
        />
        {children && children}
        {!children && <p className="leading-6">{text}</p>}
      </div>
    </div>
  );
};

export default Alert;
